import { useMemo } from 'react'

import { buildTrack } from './buildTrack'
import { normalize } from './normalize'
import { getPH } from './phClient'
import { shouldSendOnce } from './shouldSendOnce'

export function useAnalytics() {
  const ph = getPH()

  const track = useMemo(() => buildTrack(), [ph])

  return {
    ph,
    track,
    normalize,
    shouldSendOnce
  }
}
